import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../shared/auth.service';

// Invoice pages only for who the sidebar shows them to: invoicing on for the company and
// Admin or the Invoicing grant. The API stays 403 behind Gate 'invoice'; this only avoids
// a dead page with a raw error. Waits for the user like AuthGuard does.
@Injectable({ providedIn: 'root' })
export class CanInvoiceGuard {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.user.pipe(
      filter(Boolean),
      take(1),
      map((user: any) => user.can_invoice && user.invoicing_enabled ? true : this.router.createUrlTree(['/users/me'])),
    );
  }
}
